{
  "tickets.aiForm.field.assignee": "Assignee",
  "tickets.aiForm.field.body": "Description",
  "tickets.aiForm.field.due": "Due date",
  "tickets.aiForm.field.priority": "Priority",
  "tickets.aiForm.field.status": "Status",
  "tickets.aiForm.field.title": "Title",
  "tickets.aiForm.field.type": "Type",
  "tickets.aiForm.title": "Task",
  "tickets.answer.columnMore": "+{n} more",
  "tickets.answer.due.nextWeek": "Due next week",
  "tickets.answer.due.none": "No due date",
  "tickets.answer.due.overdue": "Overdue",
  "tickets.answer.due.thisWeek": "Due this week",
  "tickets.answer.due.today": "Due today",
  "tickets.answer.empty": "No tasks match.",
  "tickets.answer.failed": "Could not load the tasks.",
  "tickets.answer.more": "The {n} most recently updated — the rest are in Tasks",
  "tickets.answer.moreOf": "{n} of {total} shown — the rest are in Tasks",
  "tickets.answer.shownCount": "{n} shown",
  "tickets.answer.title": "Tasks",
  "tickets.answer.untitled": "Untitled task",
  "tickets.approval.approvedAt": "APPROVED · {time}",
  "tickets.approval.noteLabel": "Approval note",
  "tickets.approval.rejectedAt": "REJECTED · {time}",
  "tickets.attachTask.description": "Paste the human task id (e.g. TICKET-42). The task’s cycleId will be set; one cycle per task.",
  "tickets.attachTask.field.id": "Task id",
  "tickets.attachTask.field.idPlaceholder": "TICKET-42",
  "tickets.attachTask.title": "Add task to cycle",
  "tickets.audit.hero.eyebrow": "REQUESTS · AUDIT",
  "tickets.audit.hero.headline": "Audit / Reports",
  "tickets.audit.hero.ledeMany": "{count} audits and reports.",
  "tickets.audit.hero.ledeOne": "{count} audit and report.",
  "tickets.audit.unavailable.body": "Audits and reports will appear here.",
  "tickets.board.card.assignFailedTitle": "Assign failed",
  "tickets.board.card.assignMe": "Assign to me",
  "tickets.board.card.copyFailedTitle": "Copy failed",
  "tickets.board.card.copyLink": "Copy link",
  "tickets.board.card.deleteMessage": "This permanently removes the task.",
  "tickets.board.card.deleteTitle": "Delete \"{name}\"?",
  "tickets.board.card.linkCopiedBody": "Task link copied to clipboard",
  "tickets.board.card.linkCopiedTitle": "Link copied",
  "tickets.board.card.taskFallback": "task",
  "tickets.board.create.aria": "New task or column",
  "tickets.board.create.columnHint": "Add a kanban column.",
  "tickets.board.create.columnLabel": "New Column",
  "tickets.board.create.epicsHint": "Create, rename or remove epics.",
  "tickets.board.create.epicsLabel": "Manage epics",
  "tickets.board.create.taskHint": "Create a task on this board.",
  "tickets.board.create.taskLabel": "New Task",
  "tickets.board.filters.show": "Show filters",
  "tickets.board.filters.title": "Filters",
  "tickets.board.help.click": "Click a card to open it.",
  "tickets.board.help.drag": "Drag cards between columns.",
  "tickets.board.moreCount": "More · {loaded} / {total}",
  "tickets.board.newColumn.failedBody": "Create failed",
  "tickets.board.newColumn.failedTitle": "Column not created",
  "tickets.board.newColumn.message": "Name for the new column.",
  "tickets.board.newColumn.placeholder": "e.g. Blocked",
  "tickets.board.newColumn.title": "New column",
  "tickets.card.epicBadge": "EPIC",
  "tickets.card.parent": "parent",
  "tickets.card.parentTooltip": "Parent: {url}",
  "tickets.cycleEdit.create": "Create cycle",
  "tickets.cycleEdit.description": "Group a set of tasks ahead of a release. Name + optional dates.",
  "tickets.cycleEdit.field.description": "Description (optional)",
  "tickets.cycleEdit.field.descriptionPlaceholder": "What’s the focus of this cycle?",
  "tickets.cycleEdit.field.ends": "Ends",
  "tickets.cycleEdit.field.name": "Name",
  "tickets.cycleEdit.field.namePlaceholder": "e.g. Sprint 42, Q3 release, …",
  "tickets.cycleEdit.field.starts": "Starts",
  "tickets.cycleEdit.nameRequired": "Give the cycle a name.",
  "tickets.cycleEdit.saving": "Saving…",
  "tickets.cycleEdit.titleEdit": "Edit cycle",
  "tickets.cycleEdit.titleNew": "New cycle",
  "tickets.delete.failedMany": "{count} of {total} tasks not deleted",
  "tickets.delete.failedMessage": "The server refused. What was not deleted is back in the list.",
  "tickets.delete.failedOne": "Task not deleted",
  "tickets.deps.kind.blockedBy": "blocked by",
  "tickets.deps.kind.blocks": "blocks",
  "tickets.deps.kind.related": "related",
  "tickets.deps.kind.waitsOnShip": "waits on ship",
  "tickets.detail.action.askAi": "Ask AI about this task",
  "tickets.detail.action.attachFile": "Attach a file",
  "tickets.detail.action.copied": "Copied!",
  "tickets.detail.action.copyUrl": "Copy task URL",
  "tickets.detail.action.createTask": "Create task",
  "tickets.detail.action.delete": "Delete task",
  "tickets.detail.action.dismiss": "Dismiss",
  "tickets.detail.action.edit": "Edit task",
  "tickets.detail.action.openFullView": "Open in full view",
  "tickets.detail.action.saveChanges": "Save changes",
  "tickets.detail.action.sendToAi": "Send to AI",
  "tickets.detail.aiPrompt.placeholder": "Ask AI to fill fields, improve the description, add acceptance criteria…",
  "tickets.detail.aiUpdate.actionAssignee": "Assignee → {value}",
  "tickets.detail.aiUpdate.actionBody": "New description",
  "tickets.detail.aiUpdate.actionColumn": "Status → {value}",
  "tickets.detail.aiUpdate.actionPriority": "Priority → {value}",
  "tickets.detail.aiUpdate.actionTitle": "Title → “{value}”",
  "tickets.detail.aiUpdate.confirmTitle": "Apply the AI changes to “{name}”?",
  "tickets.detail.aiUpdate.done": "Done.",
  "tickets.detail.aiUpdate.failed": "AI changes not saved",
  "tickets.detail.aiUpdate.failedMessage": "The server refused them. The task keeps its earlier values.",
  "tickets.detail.aiUpdate.notApplied": "Not applied.",
  "tickets.detail.aiUpdate.notSaved": "Not saved. The task keeps its earlier values.",
  "tickets.detail.aiUpdate.nothing": "The AI found nothing to change.",
  "tickets.detail.aiUpdate.proposed": "Suggested changes:",
  "tickets.detail.aiUpdate.requestFailed": "The AI request failed: {error}",
  "tickets.detail.aiUpdate.thinking": "Thinking…",
  "tickets.detail.aiUpdate.unknownError": "unknown error",
  "tickets.detail.aiUpdate.unreadable": "Could not read the AI answer.",
  "tickets.detail.approval.approve": "Approve",
  "tickets.detail.approval.approveFailed": "Approval failed",
  "tickets.detail.approval.approveMessage": "Agents can then start work on it. The note “{note}” goes into the comments.",
  "tickets.detail.approval.approveTitle": "Approve “{name}”?",
  "tickets.detail.approval.approving": "Approving…",
  "tickets.detail.approval.awaiting": "Awaiting your approval",
  "tickets.detail.approval.defaultApproveNote": "Approved.",
  "tickets.detail.approval.defaultRejectNote": "Needs changes.",
  "tickets.detail.approval.notePlaceholder": "Approval note (default: Approved.)",
  "tickets.detail.approval.reject": "Reject",
  "tickets.detail.approval.rejectFailed": "Rejection failed",
  "tickets.detail.approval.rejectMessage": "The task goes back for changes and waits for approval again. The note “{note}” goes into the comments.",
  "tickets.detail.approval.rejectTitle": "Reject “{name}”?",
  "tickets.detail.approval.rejecting": "Rejecting…",
  "tickets.detail.attachment.fileFallback": "file",
  "tickets.detail.attachment.removeFailed": "File not removed",
  "tickets.detail.attachment.removeMessage": "It leaves this task for everyone.",
  "tickets.detail.attachment.removeTitle": "Remove “{name}”?",
  "tickets.detail.attachment.title": "Attachments",
  "tickets.detail.attachment.uploadFailed": "Upload failed",
  "tickets.detail.attachment.uploading": "Uploading…",
  "tickets.detail.autoTest": "Auto-test by QA agent",
  "tickets.detail.comments.loadMore": "Load more comments",
  "tickets.detail.comments.loadingMore": "Loading…",
  "tickets.detail.comments.edited": "edited",
  "tickets.detail.comments.editLabel": "Edit comment",
  "tickets.detail.comments.deleteTitle": "Delete this comment?",
  "tickets.detail.comments.deleteMessage": "The comment is removed from this task for everyone. This can’t be undone.",
  "tickets.detail.comments.deleteFailed": "Couldn’t delete the comment",
  "tickets.detail.comments.editFailed": "Couldn’t save the comment",
  "tickets.detail.comments.writeFailedMessage": "Nothing was changed. Try again.",
  "tickets.detail.composer.commentPh": "Add a comment…",
  "tickets.detail.composer.mailReplyPh": "Write the email reply…",
  "tickets.detail.composer.updatePh": "Describe what changed (AI will summarize)…",
  "tickets.detail.delete.confirmMessage": "This permanently removes the task. This cannot be undone.",
  "tickets.detail.delete.confirmTitle": "Delete \"{name}\"?",
  "tickets.detail.deps.blockedBy": "Blocked by",
  "tickets.detail.deps.blocks": "Blocks",
  "tickets.detail.deps.empty": "No matching tasks",
  "tickets.detail.deps.loadError": "Could not load tasks to search.",
  "tickets.detail.deps.remove": "Remove dependency",
  "tickets.detail.deps.retry": "Retry",
  "tickets.detail.deps.searchPlaceholder": "Add “Blocked by” — search tasks…",
  "tickets.detail.deps.searching": "Searching tasks…",
  "tickets.detail.epic.none": "No epic",
  "tickets.detail.field.acceptance": "Acceptance criteria",
  "tickets.detail.field.acceptancePh": "Checklist of conditions that must be met",
  "tickets.detail.field.assignees": "Assignees",
  "tickets.detail.field.created": "Created",
  "tickets.detail.field.description": "Description",
  "tickets.detail.field.descriptionPh": "Add a description…",
  "tickets.detail.field.epic": "Epic",
  "tickets.detail.field.expected": "Expected result",
  "tickets.detail.field.expectedPh": "What should have happened?",
  "tickets.detail.field.lastUpdated": "Last updated",
  "tickets.detail.field.peoplePlaceholder": "Type a name…",
  "tickets.detail.field.priority": "Priority",
  "tickets.detail.field.reporter": "Reporter",
  "tickets.detail.field.severity": "Severity",
  "tickets.detail.field.status": "Status",
  "tickets.detail.field.steps": "Steps to reproduce",
  "tickets.detail.field.stepsPh": "1. Go to page X\n2. Click here\n3. See the error",
  "tickets.detail.field.titlePlaceholder": "Task title",
  "tickets.detail.field.titleRequired": "Task title is required.",
  "tickets.detail.field.type": "Type",
  "tickets.detail.mailReply.accountNotReady": "The shared inbox is not connected yet",
  "tickets.detail.mailReply.confirmMessage": "It goes out by email from {address} to the person who wrote in. A sent email cannot be taken back.",
  "tickets.detail.mailReply.confirmPlain": "It goes out by email to the person who wrote in. A sent email cannot be taken back.",
  "tickets.detail.mailReply.confirmTitle": "Send the reply on “{name}”?",
  "tickets.detail.mailReply.failed": "Reply not sent",
  "tickets.detail.mailReply.hint": "Sends by email from",
  "tickets.detail.mailReply.noAccess": "You cannot answer from this inbox",
  "tickets.detail.mailReply.notDesk": "This inbox is not a service desk",
  "tickets.detail.mailReply.nothingToAnswer": "There is no inbound email to answer",
  "tickets.detail.mailReply.rateLimited": "Sending is rate-limited — try again soon",
  "tickets.detail.mailReply.sent": "Reply sent by email",
  "tickets.detail.removeItem": "Remove {name}",
  "tickets.detail.resolved": "resolved",
  "tickets.detail.section.aiAssistant": "AI Assistant",
  "tickets.detail.section.dependencies": "Dependencies",
  "tickets.detail.section.otherFields": "OTHER FIELDS",
  "tickets.detail.sendComment": "Send comment",
  "tickets.detail.sessionNotReady": "Session not ready. Wait a moment and try again.",
  "tickets.detail.severity.blocker": "Blocker",
  "tickets.detail.severity.critical": "Critical",
  "tickets.detail.severity.major": "Major",
  "tickets.detail.severity.minor": "Minor",
  "tickets.detail.severity.none": "No severity",
  "tickets.detail.severity.normal": "Normal",
  "tickets.detail.severity.trivial": "Trivial",
  "tickets.detail.status.backlog": "Backlog",
  "tickets.detail.status.done": "Done",
  "tickets.detail.status.todo": "To do",
  "tickets.detail.tab.comment": "Comment",
  "tickets.detail.tab.mailReply": "Reply by email",
  "tickets.detail.tab.update": "Update",
  "tickets.detail.taskFallback": "task",
  "tickets.detail.toast.circularMessage": "That task already depends on this one.",
  "tickets.detail.toast.circularTitle": "Circular dependency",
  "tickets.detail.toast.copyFailedTitle": "Copy failed",
  "tickets.detail.toast.depAttachFallbackMany": "Task saved, but {count} dependencies failed to attach.",
  "tickets.detail.toast.depAttachFallbackOne": "Task saved, but {count} dependency failed to attach.",
  "tickets.detail.toast.depNotAttachedMany": "Could not attach {count} dependencies: {titles}. Add them again from the task.",
  "tickets.detail.toast.depNotAttachedOne": "Could not attach {count} dependency: {titles}. Add it again from the task.",
  "tickets.detail.toast.depNotAttachedTitle": "Task saved — dependency not attached",
  "tickets.detail.toast.leftBoardMessage": "This ticket no longer matches the board filters, so its card was removed from the board.",
  "tickets.detail.toast.leftBoardTitle": "Saved, but off the board",
  "tickets.detail.toast.movedToStoriesMessage": "User stories and epics are planning items, so this card is no longer on the board. Open Stories to find it.",
  "tickets.detail.toast.movedToStoriesTitle": "Saved as a user story",
  "tickets.detail.toast.notFound": "Task not found in this organization.",
  "tickets.detail.toast.saveFailedMessage": "The task was not updated (the server rejected the change — an invalid status transition is the usual cause). Your edits were reverted.",
  "tickets.detail.toast.saveFailedTitle": "Couldn’t save changes",
  "tickets.detail.toast.unavailableTitle": "Task unavailable",
  "tickets.detail.toast.wrongOrg": "This task isn’t in your current organization.",
  "tickets.detail.type.bug": "BUG",
  "tickets.detail.type.none": "Type…",
  "tickets.detail.type.task": "TASK",
  "tickets.detail.type.userStory": "USER STORY",
  "tickets.detail.updatedAgo": "updated {time}",
  "tickets.editRequests.hero.eyebrow": "RESOLUTIONS · EDIT REQUESTS",
  "tickets.editRequests.hero.headline": "Edit Requests",
  "tickets.editRequests.hero.ledeMany": "{count} pull requests{open}.",
  "tickets.editRequests.hero.ledeOne": "{count} pull request{open}.",
  "tickets.editRequests.hero.ledeOpen": " · {count} open",
  "tickets.editRequests.unavailable.body": "Proposed edits will appear here as pull requests.",
  "tickets.epics.card.bugs": "{done}/{total} bugs",
  "tickets.epics.card.noStories": "no stories yet",
  "tickets.epics.card.stories": "{done}/{total} stories",
  "tickets.epics.card.tasks": "{done}/{total} tasks",
  "tickets.epics.empty": "No epics found.",
  "tickets.epics.hero.eyebrow": "ROADMAP · PRODUCT EPICS · 12 OF 13",
  "tickets.epics.hero.headline": "Epics",
  "tickets.epics.hero.lede": "{total} product epics · {active} active · rolling up {leaves} tasks + bugs. (1 system epic hidden — simona is an AI-assistant role, not a product category.)",
  "tickets.epics.manage.createFailed": "Failed to create epic — please try again.",
  "tickets.epics.manage.deleteConfirmMessage": "This permanently removes the epic. This cannot be undone.",
  "tickets.epics.manage.deleteConfirmTitle": "Delete \"{name}\"?",
  "tickets.epics.manage.deleteConsequenceMany": "{count} tasks are still tagged \"{name}\" — deleting the epic does NOT remove that label from them; they'll keep showing \"{name}\" until reassigned. This cannot be undone.",
  "tickets.epics.manage.deleteConsequenceOne": "{count} task is still tagged \"{name}\" — deleting the epic does NOT remove that label from it; it will keep showing \"{name}\" until reassigned. This cannot be undone.",
  "tickets.epics.manage.deleteFailed": "Failed to delete — please try again.",
  "tickets.epics.manage.deleteTooltip": "Delete epic",
  "tickets.epics.manage.description": "Epics are tasks (type: epic) that other tasks reference by name. Renaming or deleting one only changes the epic itself — tasks already tagged with the old name keep that label until reassigned.",
  "tickets.epics.manage.done": "Done",
  "tickets.epics.manage.duplicate": "\"{name}\" already exists.",
  "tickets.epics.manage.empty": "No epics yet. Add one above to start grouping tasks.",
  "tickets.epics.manage.nameRequired": "Name is required.",
  "tickets.epics.manage.newPlaceholder": "New epic name…",
  "tickets.epics.manage.renameFailed": "Failed to rename — please try again.",
  "tickets.epics.manage.renameTooltip": "Rename epic",
  "tickets.epics.manage.title": "Manage epics",
  "tickets.epics.stat.bugs": "bugs",
  "tickets.epics.stat.epics": "epics",
  "tickets.epics.stat.percentDone": "% done",
  "tickets.epics.stat.stories": "stories",
  "tickets.epics.stat.tasks": "tasks",
  "tickets.features.empty": "No features found.",
  "tickets.feed.activity.empty": "No recent activity yet.",
  "tickets.feed.activity.title": "Recent activity",
  "tickets.feed.hero.eyebrow": "WORKSPACE · FEED",
  "tickets.feed.hero.headline": "Feed",
  "tickets.feed.hero.lede": "{events} recent activity events · {standups} recent standups · digest of logs and standups.",
  "tickets.feed.seeAllFallback": "View all",
  "tickets.feed.standupFallback": "Standup",
  "tickets.feed.standups.empty": "No standup history yet.",
  "tickets.feed.standups.seeAll": "View all standups",
  "tickets.feed.standups.title": "Latest standups",
  "tickets.filter.anyEpic": "Any epic",
  "tickets.filter.anyone": "Anyone",
  "tickets.general.approvals.approve": "Approve",
  "tickets.general.approvals.confirmMessage": "Agents can then start work on it.",
  "tickets.general.approvals.confirmTitle": "Approve “{name}”?",
  "tickets.general.approvals.failed": "Approval failed",
  "tickets.general.approvals.failedMessage": "The server refused it. The task is back in the list.",
  "tickets.general.approvals.glyphTooltip": "Requires human approval before agents can proceed",
  "tickets.general.approvals.hint": "Waiting for human approval before agents can proceed",
  "tickets.general.approvals.title": "Pending approvals",
  "tickets.general.blocked.hint": "Waiting on external dependency or approval before work can resume",
  "tickets.general.blocked.title": "Blocked",
  "tickets.general.blockedBy.chipTitled": "Blocked by: {title}",
  "tickets.general.blockedBy.chipUntitled": "Blocked by task #{id}",
  "tickets.general.blockedBy.label": "blocked by",
  "tickets.general.blockedBy.tooltip": "Blocked by",
  "tickets.general.decisions.glyphTooltip": "Decision task — awaiting user input",
  "tickets.general.decisions.hint": "ASK-USER tasks awaiting a decision before agents can proceed",
  "tickets.general.decisions.title": "Decisions needed",
  "tickets.general.density.comfortable": "Comfortable",
  "tickets.general.density.comfortableTooltip": "Comfortable view — standard card padding",
  "tickets.general.density.compact": "Compact",
  "tickets.general.density.compactTooltip": "Compact view — tighter card padding",
  "tickets.general.density.label": "View",
  "tickets.general.epicChip.clear": "clear",
  "tickets.general.group.allTasks": "All tasks",
  "tickets.general.group.noEpic": "Unassigned to epic",
  "tickets.general.group.noStory": "Unassigned to story",
  "tickets.general.groupBy.assignee": "Assignee",
  "tickets.general.groupBy.epic": "Epic",
  "tickets.general.groupBy.label": "Group by",
  "tickets.general.groupBy.none": "None",
  "tickets.general.groupBy.priority": "Priority",
  "tickets.general.groupBy.state": "State",
  "tickets.general.groupBy.story": "Story",
  "tickets.general.groupBy.tooltip": "Group by {label} (press {index})",
  "tickets.general.hero.eyebrow": "WORKSPACE · LIVE TRIAGE",
  "tickets.general.hero.failed": "Failed to load triage — see retry below",
  "tickets.general.hero.headline": "General",
  "tickets.general.hero.lede": "{now} now · {ongoing} ongoing{blocked} · {upcoming} upcoming · {ready} ready-to-test{pending}{decisions} (scope: {scope})",
  "tickets.general.hero.ledeBlocked": "{count} blocked",
  "tickets.general.hero.ledeDecisions": "{count} decisions",
  "tickets.general.hero.ledePending": "{count} pending approval",
  "tickets.general.hero.loading": "Loading triage…",
  "tickets.general.hero.scopeAll": "all",
  "tickets.general.live": "LIVE",
  "tickets.general.liveBadge": "live",
  "tickets.general.loadError.hint": "The request timed out. Check your connection and try again.",
  "tickets.general.loadError.retry": "Retry",
  "tickets.general.loadError.title": "Couldn’t load tasks",
  "tickets.general.pulse.empty": "No agents pulsing in the last 5 minutes",
  "tickets.general.pulse.title": "Agents pulsing now",
  "tickets.general.quickCreate.hint": "Press c to focus",
  "tickets.general.quickCreate.placeholder": "Quick-create task in active bucket… (press c)",
  "tickets.general.readyToTest.badge": "ready to test",
  "tickets.general.readyToTest.empty": "No tasks ready to test",
  "tickets.general.readyToTest.title": "Ready to test",
  "tickets.general.searchPlaceholder": "Search tasks…",
  "tickets.general.section.now": "Now",
  "tickets.general.section.nowHint": "Agents actively working right now · live heartbeat < 10m",
  "tickets.general.section.ongoing": "Ongoing",
  "tickets.general.section.ongoingHint": "Picked up but no live heartbeat · agent paused or between ticks",
  "tickets.general.section.upcoming": "Upcoming",
  "tickets.general.section.upcomingHint": "Assigned but not yet picked up · ranked by priority",
  "tickets.general.selection.assign": "Assign…",
  "tickets.general.selection.assignAction": "Assign",
  "tickets.general.selection.assignFailed": "{count} of {total} tasks not assigned",
  "tickets.general.selection.assignMessage": "Each selected task gets this assignee.",
  "tickets.general.selection.assignTitleMany": "Assign {count} tasks to {name}?",
  "tickets.general.selection.assignTitleOne": "Assign this task to {name}?",
  "tickets.general.selection.clear": "Clear selection",
  "tickets.general.selection.count": "{count} selected",
  "tickets.general.selection.deleteMessage": "Deleted tasks leave the board for everyone. This cannot be undone.",
  "tickets.general.selection.deleteTitleMany": "Delete {count} tasks?",
  "tickets.general.selection.deleteTitleOne": "Delete this task?",
  "tickets.general.selection.failedMessage": "They stay selected, so you can try again.",
  "tickets.general.selection.move": "Move",
  "tickets.general.selection.moveFailed": "{count} of {total} tasks not moved",
  "tickets.general.selection.moveMessage": "Their status follows the column.",
  "tickets.general.selection.moveTitleMany": "Move {count} tasks to “{column}”?",
  "tickets.general.selection.moveTitleOne": "Move this task to “{column}”?",
  "tickets.general.selection.moveTo": "Move to…",
  "tickets.general.selection.noTargets": "Nothing to choose from yet.",
  "tickets.general.unassigned": "Unassigned",
  "tickets.header.audit": "Audit / Reports",
  "tickets.header.board": "Board",
  "tickets.header.canvas": "Canvas",
  "tickets.header.editRequests": "Edit Requests",
  "tickets.header.epics": "Epics & Stories",
  "tickets.header.feed": "Feed",
  "tickets.header.general": "General",
  "tickets.header.improvements": "Improvement Requests",
  "tickets.header.inbound": "Inbound",
  "tickets.header.myView": "My view",
  "tickets.header.outbound": "Outbound",
  "tickets.header.release": "Release",
  "tickets.header.requests": "Requests",
  "tickets.header.resolutions": "Resolutions",
  "tickets.header.roadmap": "Roadmap",
  "tickets.header.standups": "Standups",
  "tickets.header.tasks": "Tasks",
  "tickets.heatmap.count.kbEditMany": "{count} KB edits",
  "tickets.heatmap.count.kbEditOne": "{count} KB edit",
  "tickets.heatmap.count.meetCallMany": "{count} meet calls",
  "tickets.heatmap.count.meetCallOne": "{count} meet call",
  "tickets.heatmap.count.noteEditMany": "{count} note edits",
  "tickets.heatmap.count.noteEditOne": "{count} note edit",
  "tickets.heatmap.count.pointMany": "{count} pts",
  "tickets.heatmap.count.pointOne": "{count} pt",
  "tickets.heatmap.count.ticketUpdateMany": "{count} task updates",
  "tickets.heatmap.count.ticketUpdateOne": "{count} task update",
  "tickets.heatmap.empty": "No activity recorded for this day.",
  "tickets.heatmap.legendLess": "Less",
  "tickets.heatmap.legendMore": "More",
  "tickets.heatmap.title": "ACTIVITY · LAST YEAR",
  "tickets.heatmap.tooltip.standup": "✦ standup",
  "tickets.heatmap.type.kbEdit": "KB edit",
  "tickets.heatmap.type.meetCall": "meet call",
  "tickets.heatmap.type.noteEdit": "note edit",
  "tickets.heatmap.type.standup": "standup",
  "tickets.heatmap.type.ticketUpdate": "task update",
  "tickets.improvements.hero.eyebrow": "RESOLUTIONS · IMPROVEMENTS",
  "tickets.improvements.hero.headline": "Improvement Requests",
  "tickets.improvements.hero.ledeMany": "{count} AI-generated pages from Freestyler awaiting review.",
  "tickets.improvements.hero.ledeOne": "{count} AI-generated page from Freestyler awaiting review.",
  "tickets.improvements.unavailable.body": "AI-generated pages from Freestyler will appear here for review.",
  "tickets.inbound.hero.eyebrow": "REQUESTS · INBOUND",
  "tickets.inbound.hero.headline": "Inbound",
  "tickets.inbound.hero.ledeMany": "{count} incoming requests from customers, partners, and prospects.",
  "tickets.inbound.hero.ledeOne": "{count} incoming request from customers, partners, and prospects.",
  "tickets.inbound.unavailable.body": "Incoming requests from customers, partners, and prospects will appear here.",
  "tickets.kanban.column.review": "Review",
  "tickets.kanban.columnFallback": "Column",
  "tickets.kanban.columnOptions": "Column options",
  "tickets.kanban.draftsColumn": "Drafts",
  "tickets.kanban.empty.hint": "Drag a card here or create one with +",
  "tickets.kanban.empty.title": "No tasks yet",
  "tickets.kanban.menu.hide": "Hide",
  "tickets.kanban.menu.makeShorter": "Make shorter (1 column)",
  "tickets.kanban.menu.makeWider": "Make wider (2 columns)",
  "tickets.kanban.menu.settings": "Settings",
  "tickets.kanban.newInColumn": "New task in this column",
  "tickets.kanban.rename.failedMessage": "The server refused the new name. The column keeps its old one.",
  "tickets.kanban.rename.failedTitle": "Column not renamed",
  "tickets.kanban.rename.message": "New name for this column.",
  "tickets.kanban.rename.title": "Rename column",
  "tickets.logs.empty.hint": "Ship events and task updates will stream here in real time.",
  "tickets.logs.empty.title": "No activity yet",
  "tickets.logs.hero.eyebrow": "WORKSPACE · ACTIVITY LOG",
  "tickets.logs.hero.headline": "Logs",
  "tickets.logs.hero.lede": "{count} recent events",
  "tickets.main.githubSync": "Refresh from GitHub Projects",
  "tickets.main.lens.agents": "Agents",
  "tickets.main.lens.all": "All",
  "tickets.main.lens.me": "Me",
  "tickets.main.lens.team": "Team",
  "tickets.myView.action.later": "Later",
  "tickets.myView.action.readyToReview": "Ready to Review",
  "tickets.myView.action.startOn": "Start on",
  "tickets.myView.askUserBadge": "ASK USER",
  "tickets.myView.asked.emphasis": "asked you",
  "tickets.myView.asked.lead": "Others ",
  "tickets.myView.countMany": " · {count} tasks",
  "tickets.myView.countOne": " · {count} task",
  "tickets.myView.hero.eyebrow": "YOUR WORK · TODAY",
  "tickets.myView.hero.headline": "Hi {name}.",
  "tickets.myView.hero.headlineNoName": "Hi there.",
  "tickets.myView.hero.ledeEmpty": "No open tasks assigned to you. Nice!",
  "tickets.myView.hero.ledeMany": "You have {count} tasks on your plate.",
  "tickets.myView.hero.ledeOne": "You have {count} task on your plate.",
  "tickets.myView.working.dropHint": "Drag a task here to start working",
  "tickets.myView.working.emphasis": "working on",
  "tickets.myView.working.lead": "Currently ",
  "tickets.outbound.hero.eyebrow": "REQUESTS · OUTBOUND",
  "tickets.outbound.hero.headline": "Outbound",
  "tickets.outbound.hero.ledeMany": "{count} outreach items — proposals, follow-ups, and communications.",
  "tickets.outbound.hero.ledeOne": "{count} outreach item — proposals, follow-ups, and communications.",
  "tickets.outbound.unavailable.body": "Outreach items — proposals, follow-ups, and communications — will appear here.",
  "tickets.page.board.title": "Board / Tasks",
  "tickets.page.epics.title": "Features / Tasks",
  "tickets.page.feed.title": "Feed / Tasks",
  "tickets.page.general.title": "General / Tasks",
  "tickets.page.logs.title": "Logs / Tasks",
  "tickets.page.myView.title": "My view / Tasks",
  "tickets.page.release.title": "Release / Tasks",
  "tickets.page.requests.title": "Customer requests / Resolutions",
  "tickets.page.requestsAudit.title": "Audit / Reports / Resolutions",
  "tickets.page.requestsInbound.title": "Inbound / Resolutions",
  "tickets.page.requestsOutbound.title": "Outbound / Resolutions",
  "tickets.page.resolutions.title": "Resolutions",
  "tickets.page.resolutionsEditRequests.title": "Edit requests / Resolutions",
  "tickets.page.resolutionsImprovements.title": "Improvements / Resolutions",
  "tickets.page.roadmap.title": "Roadmap / Tasks",
  "tickets.page.standups.title": "Standups / Tasks",
  "tickets.page.stories.title": "Stories / Tasks",
  "tickets.page.view.title": "Task",
  "tickets.priority.option.none": "No priority",
  "tickets.priority.option.p0": "P0 · Critical",
  "tickets.priority.option.p1": "P1 · High",
  "tickets.priority.option.p2": "P2 · Medium",
  "tickets.priority.option.p3": "P3 · Low",
  "tickets.release.changelog": "Changelog",
  "tickets.release.hero.eyebrow": "TICKETS · RELEASE PIPELINE",
  "tickets.release.hero.headline": "Release",
  "tickets.release.hero.lede": "{count} task(s) queued for staging. {matrixNote}",
  "tickets.release.hero.matrixPending": "Version matrix pending.",
  "tickets.release.hero.matrixReady": "Versions sourced from system-status.",
  "tickets.release.history.empty": "No releases on record yet.",
  "tickets.release.history.eyebrow": "HISTORY",
  "tickets.release.history.title": "Past releases",
  "tickets.release.pipeline.description": "Current dev / staging / prod versions per repo. Sourced from the same system-status edge function used by /system-status, so this view always reflects the live release cycle.",
  "tickets.release.pipeline.eyebrow": "PIPELINE · LIVE VERSIONS",
  "tickets.release.pipeline.loadError": "Couldn’t load live versions. Refresh to try again.",
  "tickets.release.pipeline.repoColumn": "Repo",
  "tickets.release.pipeline.title": "Versions",
  "tickets.release.promote.buttonTooltip": "Open main → release PRs across workspace, server, sdk via the github-sync App",
  "tickets.release.promote.confirmAction": "Open release PRs",
  "tickets.release.promote.confirmMessage": "Opens \"{repos}\" PRs from `main` → `release` via the github-sync App. {count} task(s) currently queued for staging will ride along once each PR merges. Idempotent — already-open PRs are reused, not duplicated.",
  "tickets.release.promote.confirmTitle": "Open main → release PRs across {count} repos?",
  "tickets.release.promote.done": "Release PRs opened",
  "tickets.release.promote.doneMessage": "The links are under the button.",
  "tickets.release.promote.failed": "Release PRs not opened",
  "tickets.release.promote.forbidden": "Only a manager can open release PRs.",
  "tickets.release.promote.notOpenedIn": "Not opened in: {repos}",
  "tickets.release.promote.openedLabel": "Opened PRs",
  "tickets.release.promote.pending": "Opening PRs…",
  "tickets.release.showMoreMany": "Show {count} more",
  "tickets.release.showMoreOne": "Show {count} more",
  "tickets.release.stage1.description": "Tasks merged to main, awaiting QA confirmation on the main→release preview. Opens GitHub compare-PR forms for workspace + server + sdk so you can promote in one click each.",
  "tickets.release.stage1.empty": "Nothing waiting for staging. Mark a task as Ready to Test once its PR merges to main.",
  "tickets.release.stage1.eyebrow": "STAGE 1 · MAIN → RELEASE",
  "tickets.release.stage1.queued": "Queued for staging · {count}",
  "tickets.requests.hero.eyebrow": "REQUESTS",
  "tickets.requests.hero.headline": "Customer Requests",
  "tickets.requests.hero.ledeMany": "{count} requests from customers, partners, and community.",
  "tickets.requests.hero.ledeOne": "{count} request from customers, partners, and community.",
  "tickets.requests.unavailable.body": "Requests from customers, partners, and the community will appear here.",
  "tickets.resolutions.clearFilters": "× Clear filters",
  "tickets.resolutions.date.today": "Today",
  "tickets.resolutions.date.unknown": "Unknown date",
  "tickets.resolutions.date.yesterday": "Yesterday",
  "tickets.resolutions.dateFilterTooltip": "Show resolutions from this date onwards",
  "tickets.resolutions.group.requests": "REQUESTS",
  "tickets.resolutions.group.resolutions": "RESOLUTIONS",
  "tickets.resolutions.groupBy.agent": "Agent",
  "tickets.resolutions.groupBy.date": "Date",
  "tickets.resolutions.groupBy.label": "GROUP BY",
  "tickets.resolutions.groupBy.story": "Story",
  "tickets.resolutions.hero.eyebrow": "AGENT MEMORY · RESOLUTIONS",
  "tickets.resolutions.hero.headline": "Resolutions",
  "tickets.resolutions.hero.lede": "{count} agent resolutions · newest first.",
  "tickets.resolutions.hero.ledeEmpty": "No resolution tasks yet. Agents will populate this as they ship fixes.",
  "tickets.resolutions.hero.ledeFiltered": "{shown} of {total} resolutions · filtered.",
  "tickets.resolutions.nav.aria": "Resolutions navigation",
  "tickets.resolutions.nav.audit": "Audit / Reports",
  "tickets.resolutions.nav.customerRequests": "Customer requests",
  "tickets.resolutions.nav.editRequests": "Edit requests",
  "tickets.resolutions.nav.improvements": "Improvement requests",
  "tickets.resolutions.nav.inbound": "Inbound",
  "tickets.resolutions.nav.outbound": "Outbound",
  "tickets.resolutions.nav.resolutions": "Resolutions",
  "tickets.resolutions.noLinkedTask": "No linked task",
  "tickets.resolutions.panelFallback": "Resolution",
  "tickets.resolutions.searchPlaceholder": "Search resolutions…",
  "tickets.resolutions.section.filesTouched": "Files Touched",
  "tickets.resolutions.section.fix": "Fix",
  "tickets.resolutions.section.prevention": "Prevention",
  "tickets.resolutions.section.rootCause": "Root Cause",
  "tickets.resolutions.section.summary": "Summary",
  "tickets.roadmap.action.activate": "Activate",
  "tickets.roadmap.action.activateTooltip": "Mark this as the current active cycle",
  "tickets.roadmap.action.addTask": "Add task",
  "tickets.roadmap.action.archive": "Archive cycle",
  "tickets.roadmap.action.board": "Board",
  "tickets.roadmap.action.boardTooltip": "Open this cycle on the board",
  "tickets.roadmap.action.edit": "Edit cycle",
  "tickets.roadmap.action.hideTasks": "Hide tasks",
  "tickets.roadmap.action.release": "Release",
  "tickets.roadmap.action.releaseTooltip": "Open the release pipeline page",
  "tickets.roadmap.action.removeFromCycle": "Remove from cycle",
  "tickets.roadmap.action.showTasks": "Show tasks",
  "tickets.roadmap.activate.confirmMessage": "It becomes the current cycle.",
  "tickets.roadmap.activate.confirmSwitch": "It becomes the current cycle in place of “{current}”.",
  "tickets.roadmap.activate.confirmTitle": "Activate “{name}”?",
  "tickets.roadmap.activate.failed": "Cycle not activated",
  "tickets.roadmap.archive.confirmAction": "Archive",
  "tickets.roadmap.archive.confirmMessage": "Archived cycles hide from the active roadmap but tasks keep their cycleId for history.",
  "tickets.roadmap.archive.confirmTitle": "Archive \"{name}\"?",
  "tickets.roadmap.archive.failed": "Cycle not archived",
  "tickets.roadmap.detach.confirmMessage": "The task stays on the board. Only its link to the cycle goes.",
  "tickets.roadmap.detach.confirmTitle": "Remove “{name}” from “{cycle}”?",
  "tickets.roadmap.detach.failed": "Task not removed from the cycle",
  "tickets.roadmap.due": "due {date}",
  "tickets.roadmap.empty": "No tasks attached yet.",
  "tickets.roadmap.emptyManager": "No cycles yet. Press “New cycle” to make your first planning window.",
  "tickets.roadmap.emptyMember": "No cycles yet. Ask a manager to make one.",
  "tickets.roadmap.from": "from {date}",
  "tickets.roadmap.hero.eyebrow": "TICKETS · ROADMAP",
  "tickets.roadmap.hero.headline": "Roadmap",
  "tickets.roadmap.hero.ledeActive": "Active cycle \"{name}\" · {pct}% complete ({done}/{total}).",
  "tickets.roadmap.hero.ledeEmpty": "No cycles yet. Managers can create one to start grouping tasks toward a release.",
  "tickets.roadmap.hero.ledeInactive": "{count} cycle(s). No active cycle — activate one to flag it as current.",
  "tickets.roadmap.stats": "{pct}% · {done}/{total} tasks",
  "tickets.roadmap.untitled": "Untitled cycle",
  "tickets.roadmap.writeFailedMessage": "The server refused the change. Nothing changed.",
  "tickets.roadmapAnswer.cyclesFailed": "Could not load the cycles.",
  "tickets.roadmapAnswer.empty": "Nothing on the roadmap matches.",
  "tickets.roadmapAnswer.failed": "Could not load the roadmap.",
  "tickets.roadmapAnswer.more": "{n} of {total} shown — the rest are on the roadmap",
  "tickets.roadmapAnswer.show.all": "Cycles and epics",
  "tickets.roadmapAnswer.show.cycles": "Cycles",
  "tickets.roadmapAnswer.show.epics": "Epics",
  "tickets.roadmapAnswer.status.active": "Active",
  "tickets.roadmapAnswer.status.archived": "Archived",
  "tickets.roadmapAnswer.status.planned": "Planned",
  "tickets.roadmapAnswer.status.released": "Released",
  "tickets.roadmapAnswer.title": "Roadmap",
  "tickets.sidebar.drafts.aria": "Show drafts",
  "tickets.sidebar.drafts.label": "Drafts",
  "tickets.sidebar.group.assignee": "ASSIGNEE",
  "tickets.sidebar.group.drafts": "DRAFTS",
  "tickets.sidebar.group.epic": "EPIC",
  "tickets.sidebar.group.filterType": "FILTER TYPE",
  "tickets.sidebar.group.issuer": "ISSUER",
  "tickets.sidebar.navLabel": "Tasks filters",
  "tickets.sidebar.type.all": "All Types",
  "tickets.sidebar.type.bugs": "Bugs",
  "tickets.sidebar.type.featuresAndStories": "Features & Stories",
  "tickets.sidebar.type.tasks": "Tasks",
  "tickets.standup.action.applied": "Applied",
  "tickets.standup.action.applying": "Applying…",
  "tickets.standup.action.createTicket": "+ New task",
  "tickets.standup.action.moveTicket": "Move",
  "tickets.standup.action.newTaskFallback": "New task",
  "tickets.standup.action.skip": "Skip",
  "tickets.standup.action.skipped": "Skipped",
  "tickets.standup.action.updateTicket": "Update",
  "tickets.standup.actions.allAddressed": "All actions addressed",
  "tickets.standup.actions.pendingMany": "{count} suggested actions — confirm or skip each:",
  "tickets.standup.actions.pendingOne": "{count} suggested action — confirm or skip each:",
  "tickets.standup.aiSummary": "AI-generated summary",
  "tickets.standup.analyzing": "Analyzing your update…",
  "tickets.standup.appliedChanges": "Applied changes:",
  "tickets.standup.complete": "Standup complete — thank you for today's update!",
  "tickets.standup.confirmAll": "Confirm All & Save",
  "tickets.standup.inputPlaceholder": "What did you work on today?",
  "tickets.standup.previousLink": "Previous standups →",
  "tickets.standup.quickfill.blocked": "Blocked",
  "tickets.standup.quickfill.blockedText": "Blocked on ",
  "tickets.standup.quickfill.codeReview": "Code review",
  "tickets.standup.quickfill.codeReviewText": "Reviewed PRs and gave feedback. ",
  "tickets.standup.quickfill.done": "{name} · done",
  "tickets.standup.quickfill.doneText": "Finished {mention}, ready to close. ",
  "tickets.standup.quickfill.meetings": "Meetings",
  "tickets.standup.quickfill.meetingsText": "Attended meetings about ",
  "tickets.standup.quickfill.progress": "{name} · progress",
  "tickets.standup.quickfill.progressText": "Made progress on {mention}. ",
  "tickets.standup.quickfill.started": "Started: {name}",
  "tickets.standup.quickfill.startedText": "Started working on {mention}. ",
  "tickets.standup.reanalyze": "Re-analyze update",
  "tickets.standup.skipAll": "Skip all",
  "tickets.standup.untitled": "Untitled",
  "tickets.standups.editFailed": "Standup not saved",
  "tickets.standups.editLabel": "Edit your standup update",
  "tickets.standups.empty": "No standup history yet. Submit your first daily update!",
  "tickets.standups.hero.eyebrow": "STANDUPS",
  "tickets.standups.hero.headline": "Daily Standup History",
  "tickets.standups.hero.lede": "Your past standup summaries and action items.",
  "tickets.standups.section.actions": "ACTIONS",
  "tickets.standups.section.aiSummary": "AI SUMMARY",
  "tickets.standups.section.yourUpdate": "YOUR UPDATE",
  "tickets.state.awaitingApproval": "Awaiting Approval",
  "tickets.state.blocked": "Blocked",
  "tickets.state.cancelled": "Cancelled",
  "tickets.state.done": "Done",
  "tickets.state.inProgress": "In Progress",
  "tickets.state.notStarted": "Not Started",
  "tickets.state.readyToReview": "Ready to Review",
  "tickets.state.readyToTest": "Ready to Test",
  "tickets.state.released": "Released",
  "tickets.stories.empty": "No stories found.",
  "tickets.stories.hero.eyebrow": "ROADMAP · USER STORIES",
  "tickets.stories.hero.headline": "Stories",
  "tickets.stories.hero.lede": "{stories} stories across {epics} epics · {tasks} tasks + {bugs} bugs.",
  "tickets.story.action.openAsTask": "Open as task",
  "tickets.story.badge": "USER STORY",
  "tickets.story.empty": "No tasks or bugs linked to this story yet.",
  "tickets.story.field.acceptance": "Acceptance criteria",
  "tickets.story.field.bugs": "Bugs",
  "tickets.story.field.description": "Description",
  "tickets.story.field.progress": "Progress",
  "tickets.story.field.tasks": "Tasks",
  "tickets.story.group.bugs": "Bugs",
  "tickets.story.group.doneCount": "{done} of {total} done",
  "tickets.story.group.tasks": "Tasks",
  "tickets.unavailable.lede": "This feature is not available yet.",
  "tickets.view.backToBoard": "Back to tasks",
  "tickets.view.unavailable.title": "Task unavailable",
  "tickets.view.unavailable.failed": "Failed to load task."
}
